import { type ApolloError } from "@apollo/client";
import { type IntlShape, useIntl } from "react-intl";

import { messages } from "./messages.generated";

const ERROR_CODE_TO_MESSAGE: Record<string, keyof typeof messages> = {
    BAD_USER_INPUT: "errorBadUserInput",
    UNAUTHENTICATED: "errorUnauthenticated",
    FORBIDDEN: "errorForbidden",
    NOT_FOUND: "errorNotFound",
    RATE_LIMITED: "errorRateLimited",
    INTERNAL_SERVER_ERROR: "errorGeneric",
};

const getGraphQLErrorCode = (error: ApolloError): string | undefined =>
    error.graphQLErrors[0]?.extensions?.["code"] as string | undefined;

export const formatApolloError = (error: unknown, intl: IntlShape): string => {
    const apolloError = error as ApolloError | undefined;
    if (!apolloError?.graphQLErrors) {
        return intl.formatMessage(messages.errorGeneric);
    }

    const code = getGraphQLErrorCode(apolloError);
    const messageKey = code ? ERROR_CODE_TO_MESSAGE[code] : undefined;
    const descriptor = messageKey ? messages[messageKey] : messages.errorGeneric;

    return intl.formatMessage(descriptor);
};

export const useErrorMessage = (error: ApolloError | undefined): string | undefined => {
    const intl = useIntl();
    if (!error) return undefined;
    return formatApolloError(error, intl);
};
